<template>
  <el-dialog title="计划" :visible.sync="visible" width="60%">
    <WorkPlan v-if="visible" ref="workPlanRef" :targetId="targetId" :targetType="targetType" :managerId="managerId"></WorkPlan>
  </el-dialog>
</template>

<script>
import WorkPlan from "@/views/crm/workPlan/workPlan";


export default {
  name: "FollowAddDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      targetType: null,
      targetId: null,
      managerId: null
    };
  },
  created() {
  },
  components: {
    WorkPlan
  },
  watch: {
    visible (val) {
      if (!val) {
        this.targetId = null;
      }
    }
  },
  methods: {
    open (targetType, targetId, managerId) {
      this.targetType = targetType;
      this.targetId = targetId;
      this.managerId = managerId;
      this.visible = true;
    },
    // handleAfterWorkPlanAdd () {
    //   this.visible = false;
    //   this.$emit('success');
    // }
  }
};
</script>
